module.exports = __webpack_public_path__ + "static/media/rotatescreen.d89b2e00.svg";